/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createContactSubmission = /* GraphQL */ `
  mutation CreateContactSubmission(
    $input: CreateContactSubmissionInput!
    $condition: ModelContactSubmissionConditionInput
  ) {
    createContactSubmission(input: $input, condition: $condition) {
      id
      name
      email
      phone
      message
      zipCode
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateContactSubmission = /* GraphQL */ `
  mutation UpdateContactSubmission(
    $input: UpdateContactSubmissionInput!
    $condition: ModelContactSubmissionConditionInput
  ) {
    updateContactSubmission(input: $input, condition: $condition) {
      id
      name
      email
      phone
      message
      zipCode
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteContactSubmission = /* GraphQL */ `
  mutation DeleteContactSubmission(
    $input: DeleteContactSubmissionInput!
    $condition: ModelContactSubmissionConditionInput
  ) {
    deleteContactSubmission(input: $input, condition: $condition) {
      id
      name
      email
      phone
      message
      zipCode
      createdAt
      updatedAt
      __typename
    }
  }
`;
